import { InteractionType } from 'types/interactiveWidget.types';
import { WidgetType } from 'types/widget.types';

export const MAX_TOOLTIPS_CHARACTERS = 200;

// Which options can be used for which widget types
// TODO allow both types for all widgets
const SUPPORTED_WIDGET_INTERACTIONS = {
  [InteractionType.Expandable]: [
    WidgetType.Image,
    WidgetType.PieChart,
    WidgetType.MapChart,
    WidgetType.QRCode,
    WidgetType.AreaChart,
    WidgetType.BarChart,
    WidgetType.ComboChart,
    WidgetType.ColumnChart,
    WidgetType.HalfPieChart,
    WidgetType.HistogramChart,
    WidgetType.LineChart,
    WidgetType.StackedAreaChart,
    WidgetType.StackedBarChart,
    WidgetType.StackedColumnChart,
    WidgetType.FunnelChart,
    WidgetType.PyramidChart,
    WidgetType.ScatterPlotChart,
    WidgetType.SplineChart,
    WidgetType.CloudBubbleChart,
    WidgetType.AreaSplineChart,
    WidgetType.ScatterBubbleChart,
    // FIXME: disable temporarily for new wordcloud chart, as expandable interaction is not supported yet
    // WidgetType.WordCloudChart,
  ],
  [InteractionType.Tooltip]: [
    WidgetType.Icon,
    WidgetType.BasicShape,
    WidgetType.Line,
    WidgetType.Image,
    WidgetType.PieChart,
    WidgetType.MapChart,
    WidgetType.QRCode,
    WidgetType.AreaChart,
    WidgetType.BarChart,
    WidgetType.ComboChart,
    WidgetType.ColumnChart,
    WidgetType.HalfPieChart,
    WidgetType.HistogramChart,
    WidgetType.LineChart,
    WidgetType.SplineChart,
    WidgetType.StackedAreaChart,
    WidgetType.StackedBarChart,
    WidgetType.AreaSplineChart,
    WidgetType.TreeMapChart,
    WidgetType.StackedColumnChart,
    WidgetType.FunnelChart,
    WidgetType.PyramidChart,
    WidgetType.CloudBubbleChart,
    WidgetType.ScatterBubbleChart,
    WidgetType.ScatterPlotChart,
    WidgetType.MapChart,
    WidgetType.LineIcon,
    WidgetType.VideoEmbed,
    // FIXME: disable temporarily for new wordcloud chart, as it doesn't support interactive tooltips yet
    // WidgetType.WordCloudChart,
  ],
};

export { SUPPORTED_WIDGET_INTERACTIONS };
